export default __webpack_public_path__ + "static/media/database1.7f2bcbc8.jpeg";